<!-- 作品添加到专辑 -->
<template>
  <div class="program-management">
    <el-steps class="steps" :active="3">
      <el-step title="上传" class="icon-11"></el-step>
      <el-step title="编辑" class="icon-22"></el-step>
      <el-step title="加入专辑" class="icon-22"></el-step>
      <el-step title="发布" class="icon-33"></el-step>
    </el-steps>
    <cs-form label-width="90px" class="header-search-box padding-t-20" ref="validForm"
      form-width="100%"
      :form="searchParams"
      :formData="searchData"
      :form-col="searchFormCol"
      :inline="true">
      <template slot="search">
        <el-button type="primary" @click="search">查 询</el-button>
        <el-button size="small" @click="resetHandle('validForm')">重置</el-button>
      </template>
    </cs-form>
    <cs-table ref="multipleTable" :tableCols="tableCols" :tableData="tableData" class="no-shadow-table"
      :paginationOption="paginationOption"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler">
      <template slot="updateTime" slot-scope="scope">
        <span>{{scope.row.updateTime|timeFormat}}</span>
      </template>
       <template slot-scope="scope" slot="control">
        <el-button size="mini" @click="joinHandle(scope.row)">加入</el-button>
      </template>
    </cs-table>
  </div>
</template>
<script>
import { fetchDictionarys, fetchPushCommom } from '@/resource/api/index'
import { programSets, bindOrUnbind } from '@/resource/api/program-group-management'
export default {
  components: { },
  data () {
    return {
      isShow: false,
      programId: '', // 跳转地址栏接受节目ID
      searchParams: {
        limit: 20,
        offset: 1,
        name: '',
        operator: '',
        category: '',
        sndCategory: '',
        updateTime: ''
      },
      categoryList: [],
      secondOption: [], // 二级分类代提供接口TODO:
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableCols: [
        { prop: 'name', label: '专辑名称' },
        { prop: 'category', label: '一级分类' },
        { prop: 'sndCategory', label: '二级分类' },
        { prop: 'seriesAmount', label: '总集数' },
        { prop: 'updateTime', label: '更新时间', type: 'slot' },
        { prop: 'control', type: 'slot', label: '操作' }
      ],
      tableData: [],
      paginationOption: {}
    }
  },
  created () {
    if (this.$store.state.router.userType == 'admin') {
      this.searchParams.operator = this.$store.state.router.userName
    } else {
      this.searchParams.operator = this.$store.state.router.userInfo.username
    }
    this.paginationOption['page-size'] = this.$store.state.pageLimit
    this.searchParams.limit = this.$store.state.pageLimit
    const routerParams = this.$route.query
    this.programId = routerParams.id
    this.getData()
    this.getCategoryList()
  },
  methods: {
    // 加载数据
    getData () {
      const that = this
      programSets(that.searchParams).then((res) => {
        if (res.code == '1') {
          that.tableData = res.results
          that.paginationOption = {
            ...this.paginationOption,
            'current-page': that.searchParams.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    // 查询
    search () {
      this.currentPageHandler(1)
    },
    resetHandle (formName) {
      this.$refs[formName].resetFields()
    },
    sizeChangeHandler (val) {
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.getData(this.searchParams)
    },
    currentPageHandler (val) {
      this.searchParams.offset = val
      this.getData(this.searchParams)
    },
    joinHandle (row) {
      this.fetchBindOrUnbind(row)
    },
    fetchBindOrUnbind (row) {
      var that = this
      const data = {
        category: row.category,
        copyRightFlag: 'no',
        programSetId: row.id,
        programIds: this.programId
      }
      bindOrUnbind(data).then((res) => {
        if (res.code == 1) {
          that.$message({
            message: res.msg,
            type: 'success'
          })
          // 调用发布接口
          this.fetchPushCommom()
        } else {
          that.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }).catch(() => {})
    },
    fetchPushCommom () {
      fetchPushCommom({ id: this.programId }).then((res) => {
        if (res.code != 1) {
          this.$message({
            message: res.msg,
            type: 'error'
          })
          return false
        }
        this.$router.push({
          path: '/programManagement'
        })
      })
    },
    // 获取分类下拉框内容
    getCategoryList: function () {
      var that = this
      const data = {
        limit: 25,
        dataKey: 'category',
        dataFlag: 0
      }
      fetchDictionarys(data).then((res) => {
        if (res.code != 1) {
          that.$message({
            message: res.msg,
            type: 'error'
          })
          return false
        }
        that.categoryList = []
        res.results.map((item) => {
          that.categoryList.push({
            value: item.dataValue, label: item.dataValue
          })
        })
      })
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'name',
          type: 'input',
          label: '标题：',
          placeholder: '请输入标题查询',
          clearable: false,
          labelWidth: '60px'
        },
        {
          prop: 'category',
          label: '分类：',
          type: 'select',
          filterable: true,
          options: this.categoryList
        },
        {
          prop: 'sndCategory',
          label: '二级分类',
          multiple: true,
          type: 'select',
          options: this.secondOption
        },
        {
          prop: 'updateTime',
          label: '更新时间',
          type: 'datetime',
          timeType: 'date',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss'
        },
        { prop: 'search', type: 'slot', label: '' }
      ]
    }
  }
}
</script>
<style lang="less">
.steps {
  width: 50%;
  margin: 0 auto 70px;
  .el-step__main {
    display: inline-block;
    padding-right: 4px;
    position: absolute;
    top: -6px;
    left: 22px;
    white-space: nowrap;
    background: #fff;
  }
  .el-step__title {
    font-size: 13px;
    padding-left: 10px;
    font-weight: normal;
  }
  .icon-11 .el-step__icon.is-text ,.icon-22 .el-step__icon.is-text {
    background: #7F63F2;
    color: #fff;
    border:none
  }
  .el-step__head.is-process,.el-step__title.is-process {
    color: #7F63F2;
    border: #7F63F2;
  }
  .icon-33 .el-step__head.is-process,.el-step__title.is-process{
   color: #979797;
    border-color: #979797;
  }
  .el-step__icon-inner[class*=el-icon]:not(.is-status) {
    font-size: 20px;
  }
}

</style>
